import {ChangeDetectionStrategy, Component, HostListener, signal} from '@angular/core';

import {CovIconComponent, IconName} from '@cov/ui-angular';
import {SidebarNavigationComponent} from '../sidebar-navigation/sidebar-navigation.component';

@Component({
  selector: 'cov-mobile-navigation',
  imports: [CovIconComponent, SidebarNavigationComponent],
  templateUrl: './mobile-navigation.component.html',
  styleUrl: './mobile-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNavigationComponent {
  protected readonly iconName = IconName;

  public isOpen = signal(false);

  @HostListener('click')
  public toggle() {
    this.isOpen.set(!this.isOpen());
  }

  public close() {
    this.isOpen.set(false);
  }
}
